import { createElement } from 'react';

import { generateClassName } from '@klv/shared/utils/functions';
import Buttons from '@klv/molecules/buttons';
import { Wrapper } from '@klv/utils/wrapper';

import * as styles from './styles/header.module.scss';

import type { IHeaderProps } from '../../types';

export const Header = ({
  headline,
  headlineStyle = 'display3',
  headlineTag,
  subtext,
  subtextFontStyle,
  subtextTag,
  buttons,
  backgroundType
}: IHeaderProps) => {

  return (
    <Wrapper grid={true} contained={true} inlinePadding={true} customPadding={{ customPaddingBottom: 'lg', customPaddingTop: 'xs' }}>
      <div className={styles.header}>
        {headline && createElement(
          headlineTag || 'h2',
          { 
            className: generateClassName([headlineStyle, 'semibold', styles.headline]),
            dangerouslySetInnerHTML: { __html: headline }
          }
        )}
        {subtext && createElement(
          subtextTag || 'p',
          { 
            className: generateClassName([subtextFontStyle, styles.subtext]),
            dangerouslySetInnerHTML: { __html: subtext }
          }
        )}
        {buttons && buttons.length > 0 && (
          <Buttons buttons={buttons} buttonColor={backgroundType === 'light' ? 'dark' : 'light'} variants={['primary', 'secondary']} />
        )}
      </div>
    </Wrapper>
  );
};
